import { NgModule } from '@angular/core';

import { MaterialModule } from '../material.module';

import { ArticleBackgroundLayerComponent } from './article-background-layer/article-background-layer.component';
import { ArticleContainerComponent } from './article-container/article-container.component';
import { ArticleContentComponent } from './article-content/article-content.component';
import { ArticleFabContainerComponent } from './article-fab-container/article-fab-container.component';
import { ArticleHeaderComponent } from './article-header/article-header.component';
import { ArticleComponent } from './article/article.component';

@NgModule({
  imports: [
    MaterialModule
  ],
  declarations: [
    ArticleComponent,
    ArticleContainerComponent,
    ArticleContentComponent,
    ArticleFabContainerComponent,
    ArticleHeaderComponent,
    ArticleBackgroundLayerComponent
  ],
  exports: [
    ArticleComponent,
    ArticleContainerComponent,
    ArticleContentComponent,
    ArticleFabContainerComponent,
    ArticleHeaderComponent
  ]
})
export class ArticleModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/article/article.module.ts